import { useMemo } from 'react';

import { useTranslation } from 'providers/GILT.provider';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import { StripeCapitalDialog } from './StripeCapitalDialog.component';
import { useStripeCapitalPayloads } from './useStripeCapitalPayloads.hook';

const LAUNCH_ON_MOUNT = 1;

export const StripeCapitalAutoLaunch = () => {
  const { t } = useTranslation();
  const { payloads, salonId, merchantId, hasStripeRelationship } = useStripeCapitalPayloads();

  const errorMessages = useMemo(
    () => ({
      missingId: t('slickPay.capital.missingId'),
      noOffers: t('slickPay.capital.noOffers'),
      dismissed: t('slickPay.capital.dismissed'),
      default: t('slickPay.capital.defaultError'),
    }),
    [t],
  );

  if (!hasStripeRelationship || !payloads.length) return null;

  return <StripeCapitalDialog launchKey={LAUNCH_ON_MOUNT} salonId={salonId} merchantId={merchantId} requestPayloads={payloads} onError={alwaysNoop} errorMessages={errorMessages} />;
};
